<template>
   <div id="bank_allocation" class="bank_allocate">
        <div v-for="(v2,index) in bank_allocation_arr " track-by="$Index"> 
            <!-- BANKAllocation header -->
            <h6 class="yellow-section " style="background-color: #e0f1fc">
                <span class="voucher-label">{{bank_allocation_key}}</span>
                <span><button id="BANKALLOCATIONS_delete_button"
                        @click="delete_element(index)"
                        class="inventory-submit-btn ml-1"
                        style="float:right;"
                        type="submit">-</button></span>
            </h6>
            <div class="card-body p-2 ">
                 <div class="dx-field">
                    <div class="dx-field-label">ISDEEMEDPOSITIVE:</div>
                        <div class="dx-field-value">
                            <DxSelectBox :data-source="is_deemed_positive1"
                                         display-expr="label"
                                         value-expr="value"
                                        :value="v2.ISDEEMEDPOSITIVE"
                                        :accept-custom-value="true"
                                        v-model:selectedItem="v2.ISDEEMEDPOSITIVE"
                            />
                        </div>
                </div>

                <!-- <div class="grid grid-cols-4 gap-2 mt-1">
                    <label class="col-span-1 ml-2 font lg:text-sm md:text-xs sm:text-xs font-semibold "
                        for="">ISDEEMEDPOSITIVE: </label>
                    <select class="name mr-11 voucher-select col-span-3 xl:w-72 lg:w-64 sm:w-72 pt-0 mb-0 leading-4"
                        v-model="v2.ISDEEMEDPOSITIVE" id="">
                        <option
                            v-for="(value,key) in is_deemed_positive "
                            :value="value">{{key}}</option>
                    </select><br>
                </div> -->
            </div>
        </div>
    </div>
</template>

<script>
import DxSelectBox from 'devextreme-vue/select-box';
export default {
   name:"billallocation",
   components:{
       DxSelectBox,

   },
   props:{
        bank_allocation_arr:{
          type:Array,
          default: {}
        },
        Headers:{
          type:Array,
          default: {}
        },
        is_deemed_positive:{},
        is_deemed_positive1:{
          type:Array,
          default: {}
        },
        is_party_ledger:{},
        bank_allocation_key:''
   },
    methods:{
        delete_element(index){
            this.bank_allocation_arr.splice(index,1)
        }
    }
}
</script>
<style >
/* .bank_allocate{
    margin-left: -35px;
}
.bank{
   margin-left: 30px; 
} */
/* .bank{
    width: 260px;
    
} */
</style>